<div class="toast-container">
  @for (n of notify.notifications(); track n.id) {
    <div class="toast" [class]="'toast-' + n.type" (click)="notify.dismiss(n.id)">
      <span class="toast-icon">
        <app-icon
          [icon]="
            n.type === 'success'
              ? 'checkmark-circle-outline'
              : n.type === 'error'
                ? 'close-circle-outline'
                : 'information-circle-outline'
          "
          [size]="16"
        />
      </span>
      {{ n.message }}
    </div>
  }
</div>
